import { missingField } from 'app/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TransportationRow } from './TransportationTable';
import {
  selectEditableRequirementTypes,
  selectOfferInfo,
} from '../../../../../../../../../store/redux-store/placement-summary/selectors';
import { useSelector } from 'react-redux';
import PopOutIcon from 'app/assets/images/IconImages/PopOutIcon.svg';
import { Link, Typography } from '@mui/material';

export const Itinerary = () => {
  const { t } = useTranslation();
  const { departureItineraryLink } = useSelector(selectEditableRequirementTypes);
  const { transportation } = useSelector(selectOfferInfo);

  // Use the departureItineraryLink from offerTransportationRequirement
  const itineraryLink = transportation?.departureItineraryLink?.data ?? '';

  return (
    <TransportationRow
      id="placement-offer-transportation-itinerary"
      label={t('placement.profile.summary.offer.transportation.itinerary')}
      requirement={departureItineraryLink?.requirement}
      controlComponent={
        itineraryLink ? (
          <Link href={itineraryLink} target="_blank">
            <Typography variant="body1">
              {t('placement.profile.summary.offer.transportation.yourItinerary')}
            </Typography>
            <img src={PopOutIcon} alt="PopOut" style={{ fill: '#8e8e8e' }} />
          </Link>
        ) : (
          <div>{missingField}</div>
        )
      }
    />
  );
};
